@if(component) {
<div [style.min-height]="client.isCms  ? '40px' : 'unset'">
    <related-products [source]="source"
                      [limit]="component.limit || 8"
                      [options]="options">
        <text [content]="component"></text>
    </related-products>
</div>}
